import { Box, Button, Modal, styled, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const MainWrapper = {
  backdropFilter: "blur(5px)",
  "& .MuiBackdrop-root": { backgroundColor: "transparent" },
};
const BoxWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  maxHeight: "400px",
  backgroundColor: theme.palette.background.default,
  borderRadius: "6px",
  overflow: "hidden",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& img": { width: "100%" },
  "& .CloseBtn": {
    position: "absolute",
    top: "10px",
    right: "10px",
    minWidth: "auto",
    padding: "0",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    color: "#000000",
    backgroundColor: "#ffffff",
    opacity: "0",
    "@media screen and (max-width:600px)": {
      opacity: "1",
    },
    "& svg": {
      fontSize: "20px",
    },
    "&:focus": {
      outline: "none",
    },
  },
  "&:hover": {
    "& .CloseBtn": {
      opacity: "1",
    },
  },
}));

function ProfileImageModal({ open, handleClose, profileImage }) {
  return (
    <Modal open={open} onClose={handleClose} sx={MainWrapper}>
      <BoxWrapper>
        <Button className="CloseBtn" onClick={handleClose}>
          <CloseIcon />
        </Button>
        <Typography component="img" src={profileImage} alt="user profile" />
      </BoxWrapper>
    </Modal>
  );
}

export default ProfileImageModal;
